<template>
  <div class="chat-manage">
    <div class="left">
      <ChatLeft :messages="lastMessages.messages" :users="lastMessages.users" @sendIdChat="openChat" />
    </div>
    <div class="right" v-if="showChat">
      <ChatRight
        :id="userInfo.id"
        :username="userInfo.username"
        :dataMessages="dataMessages"
        @sendChatData="sendChat"
      />
    </div>
  </div>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import { BButton } from "bootstrap-vue";
import ChatLeft from "@/components/Chat/ChatLeft.vue";
import ChatRight from "@/components/Chat/ChatRight.vue";

export default {
  components: { BButton, ChatLeft, ChatRight },

  data() {
    return {
      tabActive: 0,
      lastMessages: [],
      showChat: false,
      userInfo: {
        id: null,
        username: null,
      },
      dataMessages: [],
      idUser: null,
    };
  },

  methods: {
    initSocket() {
      this.$socket.emit("chat", { type: "last_messages" });
      this.$socket.on("admin", this.adminSocketListener);
    },

    adminSocketListener(data) {
      if (data.type === "history") {
        this.dataMessages = data.data;
      }
      if (data.type === "message") {
        if (this.idUser === data.data.id) {
          this.dataMessages.push(data.data);
        }

        let isCreated = true;
        this.lastMessages.messages = this.lastMessages.messages.map((e) => {
          if (e.idUser === data.data.idUser) {
            isCreated = false;
            return data.data;
          }
          return e;
        });

        if (isCreated) {
          this.lastMessages.messages = [data.data].concat(this.lastMessages.messages || []);
          this.lastMessages.users[data.data.id] = data.data.username;
        }
      }
      if (data.type === "last_messages") {
        this.lastMessages = data.data;
      }
    },

    openChat(id, username) {
      this.userInfo.id = id;
      this.userInfo.username = username;
      this.showChat = true;
      this.idUser = id;
      this.$socket.emit("chat", {
        type: "history",
        data: {
          id: id,
          offset_start: 0,
          offset_end: 100,
        },
      });
    },
    formatTime(timestamp) {
      let h = new Date(timestamp).getHours();
      let m = new Date(timestamp).getMinutes();

      h = h < 10 ? "0" + h : h;
      m = m < 10 ? "0" + m : m;

      return h + ":" + m;
    },
    sendChat(textChat) {
      if (!textChat) return;
      const self = this;

      self.$socket.emit("chat", {
        type: "message",
        data: {
          to: self.idUser,
          message: textChat,
        },
      });

      const objChat = {
        message: textChat,
        time: Date.now(),
        id: null,
        idUser: self.idUser,
      };

      self.dataMessages.push(objChat);

      self.lastMessages.messages = self.lastMessages.messages.map((e) => {
        if (e.idUser === self.idUser) return objChat;
        return e;
      })
    }
  },

  watch: {},
  created() {},
  mounted() {
    this.initSocket();
    this.$store.dispatch("verticalMenu/updateUnread", { chat: 0})
  },

  beforeDestroy(){
    this.$socket.off("admin", this.adminSocketListener);
  }
};
</script>

<style lang="scss" scoped>
.chat-manage {
  display: flex;
  .left {
    width: 30%;
  }
  .right {
    width: 70%;
    margin-left: 15px;
  }
}

@media all and (max-width: 700px) {
  .chat-manage {
    display: block;
    .left {
      width: 100%;
    }
    .right {
      width: 100%;
      margin-left: 0px;
    }
  }
}
.table {
  .item {
    display: flex;
    max-width: 400px;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0 10px;
    border-bottom: 1px solid gray;
  }
}
.chat {
  margin-top: 30px;
  .item-left,
  .item-right {
    width: 100%;
    text-align: left;
    margin-bottom: 25px;
    span {
      color: #aaa;
      font-size: 14px;
      display: block;
    }
    .text {
      background-color: #dddada;
      padding: 8px 15px;
      border-radius: 8px;
      margin-top: 8px;
      max-width: 65vw;
      word-break: break-all;
      display: inline-block;
      .time {
        color: #5c5c5c;
        font-size: 12px;
        margin-left: 10px;
        display: inline;
      }
    }
  }

  .item-right {
    text-align: right;
    .text {
      background-color: #a0deff;
    }
  }
}
.chat-input {
  position: fixed;
  bottom: 0px;
  right: 0;
  display: flex;
  width: 500px;
  background-color: #f8f8f8;
  padding: 20px 28px 20px;
  input {
    padding: 10px 15px;
    width: 100%;
  }
  button {
    margin-left: 10px;
  }
}
@media all and (max-width: 500px) {
  .chat-input {
    width: 100%;
  }
}
</style>
